import type { Signal } from '@angular/core';
import { computed } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import type { TextField } from '@sitecore-jss/sitecore-jss-angular';

import type { ContentSectionTheme } from './content-section.model';

export const computedContentSectionId = (
  rendering: Signal<InnogyComponentRendering | undefined>
) => computed(() => getContentSectionId(rendering()));

export const computedContentSectionTheme = (
  rendering: Signal<InnogyComponentRendering | undefined>
) => computed(() => getContentSectionTheme(rendering()));

/** @deprecated your component should be migrated to signals and use the @see:computedContentSectionId **/
export const getContentSectionId = (
  rendering: InnogyComponentRendering | undefined
) => {
  const anchor = (rendering?.fields?.['anchor'] as TextField)?.value;
  const uid = rendering?.uid;

  if (anchor) {
    return anchor;
  }

  if (uid) {
    return `section-${uid}`;
  }

  return undefined;
};

/** @deprecated your component should be migrated to signals and use the @see:computedContentSectionTheme **/
export const getContentSectionTheme = (
  rendering: InnogyComponentRendering | undefined
) => rendering?.params?.['theme'] as ContentSectionTheme | undefined;
